import normalizeColor from "normalize-css-color";
import React from "react";
import PropTypes from "prop-types";
function _extends() {
  return (_extends = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }
    return t;
  }).apply(this, arguments);
}
function _inheritsLoose(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
function _objectWithoutProperties(t, e) {
  if (null == t) return {};
  var n,
    i,
    r = {},
    a = Object.keys(t);
  for (i = 0; i < a.length; i++) {
    n = a[i], e.indexOf(n) >= 0 || (r[n] = t[n]);
  }
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++) {
      n = o[i], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
    }
  }
  return r;
}
function _assertThisInitialized(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var Animated = function () {
    function t() {}
    var e = t.prototype;
    return e.__attach = function () {}, e.__detach = function () {}, e.__getValue = function () {}, e.__getAnimatedValue = function () {
      return this.__getValue();
    }, e.__addChild = function (t) {}, e.__removeChild = function (t) {}, e.__getChildren = function () {
      return [];
    }, t;
  }(),
  AnimatedTracking = function (t) {
    function e(e, n, i, r, a) {
      var o;
      return (o = t.call(this) || this)._value = e, o._parent = n, o._animationClass = i, o._animationConfig = r, o._callback = a, o.__attach(), o._hey = 1, o;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__getValue = function () {
      return this._parent.__getValue();
    }, n.__attach = function () {
      this._parent.__addChild(this);
    }, n.__detach = function () {
      this._parent.__removeChild(this);
    }, n.update = function () {
      this._value.animate(new this._animationClass(_extends({}, this._animationConfig, {
        toValue: this._animationConfig.toValue.__getValue()
      })), this._callback);
    }, e;
  }(Animated),
  AnimatedWithChildren = function (t) {
    function e() {
      var e;
      return (e = t.call(this) || this)._children = [], e;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__addChild = function (t) {
      t instanceof AnimatedTracking && (this._tracked = !0), 0 === this._children.length && this.__attach(), this._children.push(t);
    }, n.__removeChild = function (t) {
      var e = this._children.indexOf(t);
      -1 !== e ? (this._children.splice(e, 1), 0 === this._children.length && this.__detach()) : console.warn("Trying to remove a child that doesn't exist");
    }, n.__getChildren = function () {
      return this._children;
    }, e;
  }(Animated),
  linear = function linear(t) {
    return t;
  },
  Interpolation = function () {
    function t() {}
    return t.create = function (t) {
      if ("function" == typeof t) return function (e) {
        return t(e);
      };
      if (t.outputRange && "string" == typeof t.outputRange[0]) return createInterpolationFromStringOutputRange(t);
      var e = t.outputRange,
        n = t.inputRange,
        i = t.easing || linear,
        r = "extend";
      void 0 !== t.extrapolateLeft ? r = t.extrapolateLeft : void 0 !== t.extrapolate && (r = t.extrapolate);
      var a = "extend";
      return void 0 !== t.extrapolateRight ? a = t.extrapolateRight : void 0 !== t.extrapolate && (a = t.extrapolate), function (t) {
        var o = findRange(t, n);
        return interpolate(t, n[o], n[o + 1], e[o], e[o + 1], i, r, a);
      };
    }, t;
  }();
function interpolate(t, e, n, i, r, a, o, s) {
  var l = t;
  if (l < e) {
    if ("identity" === o) return l;
    "clamp" === o && (l = e);
  }
  if (l > n) {
    if ("identity" === s) return l;
    "clamp" === s && (l = n);
  }
  return i === r ? i : e === n ? t <= e ? i : r : (e === -1 / 0 ? l = -l : n === 1 / 0 ? l -= e : l = (l - e) / (n - e), l = a(l), i === -1 / 0 ? l = -l : r === 1 / 0 ? l += i : l = l * (r - i) + i, l);
}
function colorToRgba(t) {
  var e = normalizeColor(t);
  return null === e ? t : "rgba(" + ((4278190080 & (e = e || 0)) >>> 24) + ", " + ((16711680 & e) >>> 16) + ", " + ((65280 & e) >>> 8) + ", " + (255 & e) / 255 + ")";
}
var stringShapeRegex = /[0-9\.-]+/g;
function createInterpolationFromStringOutputRange(t) {
  var e = t.outputRange,
    n = (e = e.map(colorToRgba))[0].match(stringShapeRegex).map(function () {
      return [];
    });
  e.forEach(function (t) {
    t.match(stringShapeRegex).forEach(function (t, e) {
      n[e].push(+t);
    });
  });
  var i = e[0].match(stringShapeRegex).map(function (e, i) {
      return Interpolation.create(_extends({}, t, {
        outputRange: n[i]
      }));
    }),
    r = /^rgb/.test(e[0]);
  return function (t) {
    var n = 0;
    return e[0].replace(stringShapeRegex, function () {
      var e = i[n++](t);
      return String(r && n < 4 ? Math.round(e) : e);
    });
  };
}
function findRange(t, e) {
  for (var n = 1; n < e.length - 1 && !(e[n] >= t); ++n) {
    ;
  }
  return n - 1;
}
var AnimatedInterpolation = function (t) {
    function e(e, n) {
      var i;
      return (i = t.call(this) || this)._parents = Array.isArray(e) ? e : [e], i._interpolation = Interpolation.create(n), i;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__getValue = function () {
      return this._interpolation.apply(this, this._parents.map(function (t) {
        return t.__getValue();
      }));
    }, n.__attach = function () {
      for (var t = 0; t < this._parents.length; ++t) {
        this._parents[t] instanceof Animated && this._parents[t].__addChild(this);
      }
    }, n.__detach = function () {
      for (var t = 0; t < this._parents.length; ++t) {
        this._parents[t] instanceof Animated && this._parents[t].__removeChild(this);
      }
    }, n.interpolate = function (t) {
      return new e(this, t);
    }, e;
  }(AnimatedWithChildren),
  Animation = function () {
    function t() {}
    var e = t.prototype;
    return e.start = function (t, e, n, i) {}, e.stop = function () {}, e.__debouncedOnEnd = function (t) {
      var e = this.__onEnd;
      this.__onEnd = null, e && e(t);
    }, t;
  }(),
  _uniqueId = 0;
function findAnimatedStyles(t, e) {
  "function" == typeof t.update ? e.add(t) : t.__getChildren().forEach(function (t) {
    return findAnimatedStyles(t, e);
  });
}
var AnimatedValue = function (t) {
    function e(e) {
      var n;
      return (n = t.call(this) || this)._value = e, n._animation = null, n._animatedStyles = new Set(), n._listeners = {}, n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__detach = function () {
      this.stopAnimation();
    }, n.__getValue = function () {
      return this._value;
    }, n._flush = function () {
      (0 === this._animatedStyles.size || this._tracked) && findAnimatedStyles(this, this._animatedStyles), this._animatedStyles.forEach(function (t) {
        return t.update();
      });
    }, n._updateValue = function (t) {
      for (var e in this._value = t, this._flush(), this._listeners) {
        this._listeners[e]({
          value: this.__getValue()
        });
      }
    }, n.setValue = function (t) {
      this._animation && (this._animation.stop(), this._animation = null), this._animatedStyles.clear(), this._updateValue(t);
    }, n.stopAnimation = function (t) {
      this.stopTracking(), this._animation && this._animation.stop(), this._animation = null, t && t(this.__getValue());
    }, n.interpolate = function (t) {
      return new AnimatedInterpolation(this, t);
    }, n.animate = function (t, e) {
      var n = this,
        i = this._animation;
      this._animation && this._animation.stop(), this._animation = t, this._animatedStyles.clear(), t.start(this._value, function (t) {
        return n._updateValue(t);
      }, function (t) {
        n._animation = null, e && e(t);
      }, i);
    }, n.addListener = function (t) {
      var e = String(_uniqueId++);
      return this._listeners[e] = t, e;
    }, n.removeListener = function (t) {
      delete this._listeners[t];
    }, n.removeAllListeners = function () {
      this._listeners = {};
    }, n.stopTracking = function () {
      this._tracking && this._tracking.__detach(), this._tracking = null;
    }, n.track = function (t) {
      this.stopTracking(), this._tracking = t;
    }, e;
  }(AnimatedWithChildren),
  AnimatedArray = function (t) {
    function e(e) {
      var n;
      return (n = t.call(this) || this)._values = e.map(function (t) {
        return new AnimatedValue(t);
      }), n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.setValue = function (t) {
      var e = this;
      t.forEach(function (t, n) {
        return e._values[n].setValue(t);
      });
    }, n.__getValue = function () {
      return this._values.map(function (t) {
        return t.__getValue();
      });
    }, n.stopAnimation = function (t) {
      this._values.forEach(function (t) {
        return t.stopAnimation();
      }), t && t(this.__getValue());
    }, n.__attach = function () {
      for (var t = 0; t < this._values.length; ++t) {
        this._values[t] instanceof Animated && this._values[t].__addChild(this);
      }
    }, n.__detach = function () {
      for (var t = 0; t < this._values.length; ++t) {
        this._values[t] instanceof Animated && this._values[t].__removeChild(this);
      }
    }, e;
  }(AnimatedWithChildren),
  AnimatedTemplate = function (t) {
    function e(e, n) {
      var i;
      return (i = t.call(this) || this)._strings = e, i._values = n, i;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__transformValue = function (t) {
      return t instanceof Animated ? t.__getValue() : t;
    }, n.__getValue = function () {
      for (var t = this._strings[0], e = 0; e < this._values.length; ++e) {
        t += this.__transformValue(this._values[e]) + this._strings[1 + e];
      }
      return t;
    }, n.__attach = function () {
      for (var t = 0; t < this._values.length; ++t) {
        this._values[t] instanceof Animated && this._values[t].__addChild(this);
      }
    }, n.__detach = function () {
      for (var t = 0; t < this._values.length; ++t) {
        this._values[t] instanceof Animated && this._values[t].__removeChild(this);
      }
    }, e;
  }(AnimatedWithChildren),
  RequestAnimationFrame = {
    current: function current(t) {
      return global.requestAnimationFrame(t);
    },
    inject: function inject(t) {
      RequestAnimationFrame.current = t;
    }
  },
  CancelAnimationFrame = {
    current: function current(t) {
      return global.cancelAnimationFrame(t);
    },
    inject: function inject(t) {
      CancelAnimationFrame.current = t;
    }
  };
function tensionFromOrigamiValue(t) {
  return 3.62 * (t - 30) + 194;
}
function frictionFromOrigamiValue(t) {
  return 3 * (t - 8) + 25;
}
function fromOrigamiTensionAndFriction(t, e) {
  return {
    tension: tensionFromOrigamiValue(t),
    friction: frictionFromOrigamiValue(e)
  };
}
var SpringConfig = {
    fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction
  },
  withDefault = function withDefault(t, e) {
    return void 0 === t || null === t ? e : t;
  },
  SpringAnimation = function (t) {
    function e(e) {
      var n;
      (n = t.call(this) || this)._overshootClamping = withDefault(e.overshootClamping, !1), n._restDisplacementThreshold = withDefault(e.restDisplacementThreshold, .001), n._restSpeedThreshold = withDefault(e.restSpeedThreshold, .001), n._initialVelocity = e.velocity, n._lastVelocity = withDefault(e.velocity, 0), n._toValue = e.toValue, n.__isInteraction = void 0 === e.isInteraction || e.isInteraction;
      var i = SpringConfig.fromOrigamiTensionAndFriction(withDefault(e.tension, 40), withDefault(e.friction, 7));
      return n._tension = i.tension, n._friction = i.friction, n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.start = function (t, n, i, r) {
      if (this.__active = !0, this._startPosition = t, this._lastPosition = this._startPosition, this._onUpdate = n, this.__onEnd = i, this._lastTime = Date.now(), r instanceof e) {
        var a = r.getInternalState();
        this._lastPosition = a.lastPosition, this._lastVelocity = a.lastVelocity, this._lastTime = a.lastTime;
      }
      void 0 !== this._initialVelocity && null !== this._initialVelocity && (this._lastVelocity = this._initialVelocity), this.onUpdate();
    }, n.getInternalState = function () {
      return {
        lastPosition: this._lastPosition,
        lastVelocity: this._lastVelocity,
        lastTime: this._lastTime
      };
    }, n.onUpdate = function () {
      var t = this._lastPosition,
        e = this._lastVelocity,
        n = this._lastPosition,
        i = this._lastVelocity,
        r = Date.now();
      r > this._lastTime + 64 && (r = this._lastTime + 64);
      for (var a = Math.floor((r - this._lastTime) / 1), o = 0; o < a; ++o) {
        var s = e,
          l = this._tension * (this._toValue - n) - this._friction * i,
          u = (n = t + .001 * s / 2, i = e + .001 * l / 2),
          c = this._tension * (this._toValue - n) - this._friction * i;
        n = t + .001 * u / 2;
        var h = i = e + .001 * c / 2,
          p = this._tension * (this._toValue - n) - this._friction * i;
        n = t + .001 * h / 2;
        var f = i = e + .001 * p / 2,
          d = this._tension * (this._toValue - n) - this._friction * i;
        n = t + .001 * h / 2, i = e + .001 * p / 2, t += .001 * ((s + 2 * (u + h) + f) / 6), e += .001 * ((l + 2 * (c + p) + d) / 6);
      }
      if (this._lastTime = r, this._lastPosition = t, this._lastVelocity = e, this._onUpdate(t), this.__active) {
        var m = !1;
        this._overshootClamping && 0 !== this._tension && (m = this._startPosition < this._toValue ? t > this._toValue : t < this._toValue);
        var _ = Math.abs(e) <= this._restSpeedThreshold,
          v = !0;
        if (0 !== this._tension && (v = Math.abs(this._toValue - t) <= this._restDisplacementThreshold), m || _ && v) return 0 !== this._tension && this._onUpdate(this._toValue), void this.__debouncedOnEnd({
          finished: !0
        });
        this._animationFrame = RequestAnimationFrame.current(this.onUpdate.bind(this));
      }
    }, n.stop = function () {
      this.__active = !1, CancelAnimationFrame.current(this._animationFrame), this.__debouncedOnEnd({
        finished: !1
      });
    }, e;
  }(Animation),
  FlattenStyle = {
    current: function current(t) {
      return t;
    },
    inject: function inject(t) {
      FlattenStyle.current = t;
    }
  },
  AnimatedStyle = function (t) {
    function e(e) {
      var n;
      return n = t.call(this) || this, e = FlattenStyle.current(e) || {}, n._style = e, n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__getValue = function () {
      var t = {};
      for (var e in this._style) {
        var n = this._style[e];
        t[e] = n instanceof Animated ? n.__getValue() : n;
      }
      return t;
    }, n.__getAnimatedValue = function () {
      var t = {};
      for (var e in this._style) {
        var n = this._style[e];
        n instanceof Animated && (t[e] = n.__getAnimatedValue());
      }
      return t;
    }, n.__attach = function () {
      for (var t in this._style) {
        var e = this._style[t];
        e instanceof Animated && e.__addChild(this);
      }
    }, n.__detach = function () {
      for (var t in this._style) {
        var e = this._style[t];
        e instanceof Animated && e.__removeChild(this);
      }
    }, e;
  }(AnimatedWithChildren),
  AnimatedProps = function (t) {
    function e(e, n) {
      var i;
      return i = t.call(this) || this, e.style && (e = _extends({}, e, {
        style: new AnimatedStyle(e.style)
      })), i._props = e, i._callback = n, i.__attach(), i;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.__getValue = function () {
      var t = {};
      for (var e in this._props) {
        var n = this._props[e];
        t[e] = n instanceof Animated ? n.__getValue() : n;
      }
      return t;
    }, n.__getAnimatedValue = function () {
      var t = {};
      for (var e in this._props) {
        var n = this._props[e];
        n instanceof Animated && (t[e] = n.__getAnimatedValue());
      }
      return t;
    }, n.__attach = function () {
      for (var t in this._props) {
        var e = this._props[t];
        e instanceof Animated && e.__addChild(this);
      }
    }, n.__detach = function () {
      for (var t in this._props) {
        var e = this._props[t];
        e instanceof Animated && e.__removeChild(this);
      }
    }, n.update = function () {
      this._callback();
    }, e;
  }(Animated),
  ApplyAnimatedValues = {
    current: function current(t, e) {
      if (!t.setNativeProps) return !1;
      t.setNativeProps(e);
    },
    transformStyles: function transformStyles(t) {
      return t;
    },
    inject: function inject(t, e) {
      ApplyAnimatedValues.current = t, ApplyAnimatedValues.transformStyles = e;
    }
  };
function createAnimatedComponent(t) {
  return function (e) {
    function n() {
      return e.apply(this, arguments) || this;
    }
    _inheritsLoose(n, e);
    var i = n.prototype;
    return i.componentWillUnmount = function () {
      this._propsAnimated && this._propsAnimated.__detach();
    }, i.setNativeProps = function (t) {
      !1 === ApplyAnimatedValues.current(this.refs.node, t, this) && this.forceUpdate();
    }, i.componentWillMount = function () {
      this.attachProps(this.props);
    }, i.attachProps = function (t) {
      var e = this,
        n = this._propsAnimated;
      this._propsAnimated = new AnimatedProps(t, function () {
        !1 === ApplyAnimatedValues.current(e.refs.node, e._propsAnimated.__getAnimatedValue(), e) && e.forceUpdate();
      }), n && n.__detach();
    }, i.componentWillReceiveProps = function (t) {
      this.attachProps(t);
    }, i.render = function () {
      var e = this._propsAnimated.__getValue(),
        n = e.style,
        i = _objectWithoutProperties(e, ["style"]);
      return React.createElement(t, _extends({}, i, {
        style: ApplyAnimatedValues.transformStyles(n),
        ref: "node"
      }));
    }, n;
  }(React.Component);
}
var maybeVectorAnim = function maybeVectorAnim(t, e, n) {
    var i = e.tension,
      r = e.friction,
      a = e.toValue;
    return t instanceof AnimatedArray ? parallel(t._values.map(function (t, e) {
      return n(t, {
        tension: i,
        friction: r,
        toValue: a[e]
      });
    }), {
      stopTogether: !1
    }) : null;
  },
  spring = function t(e, n) {
    return maybeVectorAnim(e, n, t) || {
      start: function start(t) {
        var i = e,
          r = n;
        i.stopTracking(), n.toValue instanceof Animated ? i.track(new AnimatedTracking(i, n.toValue, SpringAnimation, r, t)) : i.animate(new SpringAnimation(r), t);
      },
      stop: function stop() {
        e.stopAnimation();
      }
    };
  },
  parallel = function parallel(t, e) {
    var n = 0,
      i = {},
      r = !(e && !1 === e.stopTogether),
      a = {
        start: function start(e) {
          if (n === t.length) return e && e({
            finished: !0
          });
          t.forEach(function (o, s) {
            var l = function l(o) {
              if (i[s] = !0, ++n === t.length) return n = 0, e && e(o);
              !o.finished && r && a.stop();
            };
            o ? o.start(l) : l({
              finished: !0
            });
          });
        },
        stop: function stop() {
          t.forEach(function (t, e) {
            !i[e] && t.stop(), i[e] = !0;
          });
        }
      };
    return a;
  },
  exports$1 = {
    Value: AnimatedValue,
    Array: AnimatedArray,
    spring: spring,
    template: function template(t) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++) {
        n[i - 1] = arguments[i];
      }
      return new AnimatedTemplate(t, n);
    },
    interpolate: function interpolate(t, e) {
      return new AnimatedInterpolation(values, e);
    },
    createAnimatedComponent: createAnimatedComponent,
    inject: {
      ApplyAnimatedValues: ApplyAnimatedValues.inject,
      FlattenStyle: FlattenStyle.inject,
      RequestAnimationFrame: RequestAnimationFrame.inject,
      CancelAnimationFrame: CancelAnimationFrame.inject
    },
    ApplyAnimatedValues: ApplyAnimatedValues,
    AnimatedProps: AnimatedProps
  },
  isUnitlessNumber = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  };
function prefixKey(t, e) {
  return t + e.charAt(0).toUpperCase() + e.substring(1);
}
var prefixes = ["Webkit", "ms", "Moz", "O"];
function mapStyle(t) {
  return t;
}
function dangerousStyleValue(t, e, n) {
  return null == e || "boolean" == typeof e || "" === e ? "" : n || "number" != typeof e || 0 === e || isUnitlessNumber.hasOwnProperty(t) && isUnitlessNumber[t] ? ("" + e).trim() : e + "px";
}
function setValueForStyles(t, e) {
  var n = t.style;
  for (var i in e) {
    if (e.hasOwnProperty(i)) {
      var r = 0 === i.indexOf("--"),
        a = dangerousStyleValue(i, e[i], r);
      "float" === i && (i = "cssFloat"), r ? n.setProperty(i, a) : n[i] = a;
    }
  }
}
function setValueForAttributes(t, e) {
  var n;
  for (var i in e) {
    "style" !== i && (n = e[i], t.getAttribute(i) && t.setAttribute(i, n));
  }
}
function ApplyAnimatedValues$1(t, e) {
  if (t.setNativeProps) t.setNativeProps(e);else {
    if (!t.nodeType || void 0 === t.setAttribute) return !1;
    setValueForStyles(t, e.style), setValueForAttributes(t, e);
  }
}
Object.keys(isUnitlessNumber).forEach(function (t) {
  prefixes.forEach(function (e) {
    isUnitlessNumber[prefixKey(e, t)] = isUnitlessNumber[t];
  });
}), exports$1.inject.ApplyAnimatedValues(ApplyAnimatedValues$1, mapStyle);
var elements = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].reduce(function (t, e) {
    var n;
    return _extends({}, t, ((n = {})[e] = exports$1.createAnimatedComponent(e), n));
  }, {}),
  exports$2 = _extends({}, exports$1, {
    elements: elements
  }),
  animated = exports$2.elements,
  template = exports$2.template,
  interpolate$1 = exports$2.interpolate,
  config = {
    default: {
      tension: 170,
      friction: 26
    },
    gentle: {
      tension: 120,
      friction: 14
    },
    wobbly: {
      tension: 180,
      friction: 12
    },
    stiff: {
      tension: 210,
      friction: 20
    },
    slow: {
      tension: 280,
      friction: 60
    }
  },
  Spring = function (t) {
    function e(e) {
      var n;
      return n = t.call(this) || this, _initialiseProps.call(_assertThisInitialized(n)), n.defaultAnimation = new exports$2.Value(0), n.animations = {}, n.update(e, !1), n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.update = function (t, e) {
      var n = this,
        i = t.from,
        r = t.to,
        a = t.config,
        o = t.attach,
        s = t.immediate,
        l = t.reset;
      t.onFrame;
      void 0 === e && (e = !1);
      var u = Object.entries(_extends({}, i, r)),
        c = this.defaultAnimation._value;
      this.interpolators = {}, this.defaultAnimation.setValue(0), this.animations = u.reduce(function (t, r, u) {
        var h,
          p = r[0],
          f = r[1],
          d = !1 === l && n.animations[p] || (n.animations[p] = {}),
          m = "number" == typeof f,
          _ = !m && Array.isArray(f),
          v = void 0 !== i[p] ? i[p] : f,
          g = m || _ ? f : 1;
        if (m && o) {
          var y = o(n),
            A = y && y.animations[p];
          A && (g = A.animation);
        }
        if (m) d.animation = d.interpolation = d.animation || new exports$2.Value(v);else if (_) d.animation = d.interpolation = d.animation || new exports$2.Array(v);else {
          var x = d.interpolation && d.interpolation._interpolation(c);
          d.animation = n.defaultAnimation, d.interpolation = n.defaultAnimation.interpolate({
            inputRange: [0, 1],
            outputRange: [void 0 !== x ? x : v, f]
          });
        }
        return !s || !0 !== s && -1 === s.indexOf(p) || d.animation.setValue(g), d.start = function () {
          return exports$2.spring(d.animation, _extends({
            toValue: g
          }, a)).start(0 === u && n.onRest);
        }, d.stop = function () {
          return d.animation.stopAnimation();
        }, e && d.start(), n.interpolators[p] = d.interpolation, _extends({}, t, ((h = {})[p] = d, h));
      }, {});
      var h = this.propsAnimated;
      this.propsAnimated = new exports$2.AnimatedProps(this.interpolators, this.callback), h && h.__detach();
    }, n.componentWillReceiveProps = function (t) {
      this.update(t, !0);
    }, n.componentDidMount = function () {
      Object.values(this.animations).forEach(function (t) {
        return (0, t.start)();
      });
    }, n.componentWillUnmount = function () {
      Object.values(this.animations).forEach(function (t) {
        return (0, t.stop)();
      });
    }, n.render = function () {
      var t = this.props,
        e = t.children,
        n = t.render,
        i = (t.from, t.to, t.config, t.native),
        r = _objectWithoutProperties(t, ["children", "render", "from", "to", "config", "native"]),
        a = i ? this.interpolators : this.propsAnimated.__getValue();
      return n ? n(_extends({}, a, r, {
        children: e
      })) : e(_extends({}, a, r));
    }, e;
  }(React.PureComponent);
Spring.defaultProps = {
  from: {},
  to: {},
  config: config.default,
  native: !1,
  immediate: !1,
  reset: !1
};
var _initialiseProps = function _initialiseProps() {
    var t = this;
    this.callback = function () {
      t.props.onFrame && t.props.onFrame(t.propsAnimated.__getValue()), !t.props.native && t.forceUpdate();
    }, this.onRest = function (e) {
      return e.finished && t.props.onRest && t.props.onRest();
    };
  },
  ref = function ref(t, e) {
    return "function" == typeof t ? t(e) : t;
  },
  Transition = function (t) {
    function e(e) {
      var n;
      n = t.call(this) || this;
      var i = e.children,
        r = e.render,
        a = e.keys,
        o = e.items,
        s = e.from,
        l = e.enter,
        u = (e.leave, e.update);
      return i = r || i, "function" == typeof a && (a = o.map(a)), Array.isArray(i) || (i = [i], a = a ? [a] : i), n.state = {
        transitionKeys: a,
        transitions: i.map(function (t, e) {
          var n = o ? o[e] : a[e];
          return {
            children: t,
            key: a[e],
            item: n,
            to: ref(l, n),
            from: ref(s, n),
            update: ref(u, n)
          };
        })
      }, n;
    }
    _inheritsLoose(e, t);
    var n = e.prototype;
    return n.componentWillReceiveProps = function (t) {
      var e = this,
        n = this.state,
        i = n.transitions,
        r = n.transitionKeys,
        a = t.children,
        o = t.render,
        s = t.keys,
        l = t.items,
        u = t.from,
        c = t.enter,
        h = t.leave,
        p = t.update;
      a = o || a, "function" == typeof s && (s = l.map(s)), Array.isArray(a) || (a = [a], s = s ? [s] : a);
      var f = new Set(s),
        d = new Set(r),
        m = s.filter(function (t) {
          return !d.has(t);
        }),
        _ = r.filter(function (t) {
          return !f.has(t);
        }),
        v = s.filter(function (t) {
          return d.has(t);
        });
      i = i.map(function (t) {
        if (void 0 === t.destroy) {
          var e = s.indexOf(t.key),
            n = a[e];
          n && (t.children = n), p && -1 !== v.indexOf(t.key) && (t.to = ref(p, l ? l[e] : s[e]) || t.to);
        }
        return t;
      }), m.length && m.forEach(function (t) {
        var e = s.indexOf(t),
          n = a[e],
          r = l ? l[e] : s[e],
          o = {
            children: n,
            key: s[e],
            item: r,
            to: ref(c, r),
            from: ref(u, r)
          };
        i = i.slice(0, e).concat([o], i.slice(e));
      }), _.length && _.forEach(function (t) {
        var n = i.find(function (e) {
          return e.key === t;
        });
        if (n) {
          var r = {
            destroy: !0,
            children: n.children,
            key: n.key,
            to: ref(h, n.item),
            from: ref(u, n.item),
            onRest: function onRest() {
              return e.setState(function (t) {
                return {
                  transitions: t.transitions.filter(function (t) {
                    return t !== r;
                  })
                };
              });
            }
          };
          i = i.map(function (t) {
            return t === n ? r : t;
          });
        }
      }), r = i.filter(function (t) {
        return void 0 === t.destroy;
      }).map(function (t) {
        return t.key;
      });
      var g = s.map(function (t) {
        return i.find(function (e) {
          return e.key === t;
        });
      });
      _.forEach(function (t) {
        var e = i.findIndex(function (e) {
            return e.key === t;
          }),
          n = i.find(function (e) {
            return e.key === t;
          });
        n && (g = g.slice(0, e).concat([n], g.slice(e)));
      }), this.setState({
        transitions: g,
        transitionKeys: r
      });
    }, n.render = function () {
      var t = this,
        e = this.props,
        n = e.render,
        i = (e.from, e.enter, e.leave, e.native),
        r = e.config,
        a = (e.keys, e.items, e.onFrame),
        o = _extends({
          native: i,
          config: r
        }, _objectWithoutProperties(e, ["render", "from", "enter", "leave", "native", "config", "keys", "items", "onFrame"]));
      return this.state.transitions.map(function (e) {
        var i = e.key,
          r = e.item,
          s = e.children,
          l = _objectWithoutProperties(e, ["key", "item", "children"]);
        return React.createElement(Spring, _extends({
          key: i
        }, l, o, {
          onFrame: a && function (t) {
            return a(r, t);
          },
          render: n && s,
          children: n ? t.props.children : s
        }));
      });
    }, e;
  }(React.PureComponent);
Transition.defaultProps = {
  from: {},
  enter: {},
  leave: {},
  native: !1,
  config: config.default
};
var _class,
  _temp,
  Trail = function (t) {
    function e() {
      return t.apply(this, arguments) || this;
    }
    return _inheritsLoose(e, t), e.prototype.render = function () {
      var t = this.props,
        e = t.children,
        n = t.render,
        i = t.from,
        r = t.to,
        a = t.native,
        o = t.config,
        s = t.keys,
        l = _objectWithoutProperties(t, ["children", "render", "from", "to", "native", "config", "keys"]),
        u = new Set(),
        c = _extends({}, l, {
          native: a,
          config: o,
          from: i,
          to: r
        });
      return (n || e).map(function (t, i) {
        return React.createElement(Spring, _extends({
          key: s[i]
        }, c, {
          attach: function attach(t) {
            return function (t, e) {
              return u.add(e), 0 === t ? void 0 : Array.from(u)[t - 1];
            }(i, t);
          },
          render: n && t,
          children: n ? e : t
        }));
      });
    }, e;
  }(React.PureComponent);
Trail.defaultProps = {
  from: {},
  to: {},
  native: !1,
  config: config.default
};
var Parallax = function (t) {
  function e(e) {
    var n;
    return n = t.call(this, e) || this, _initialiseProps$1.call(_assertThisInitialized(n)), n.state = {
      ready: !1
    }, n.layers = [], n.space = 0, n.current = 0, n.offset = 0, n.busy = !1, n;
  }
  _inheritsLoose(e, t);
  var n = e.prototype;
  return n.scrollTo = function (t) {
    var e = this.props,
      n = e.horizontal,
      i = e.config;
    this.scrollStop(), this.offset = t;
    var r = this.refs.container;
    this.animatedScroll = new exports$2.Value(r[n ? "scrollLeft" : "scrollTop"]), this.animatedScroll.addListener(function (t) {
      var e = t.value;
      return r[n ? "scrollLeft" : "scrollTop"] = e;
    }), exports$2.spring(this.animatedScroll, _extends({
      toValue: t * this.space
    }, i)).start();
  }, n.getChildContext = function () {
    return {
      parallax: this
    };
  }, n.componentDidMount = function () {
    window.addEventListener("resize", this.updateRaf, !1), this.update(), this.setState({
      ready: !0
    });
  }, n.componentWillUnmount = function () {
    window.removeEventListener("resize", this.updateRaf, !1);
  }, n.componentDidUpdate = function () {
    this.update();
  }, n.render = function () {
    var t,
      e = this.props,
      n = e.style,
      i = e.innerStyle,
      r = e.pages,
      a = e.className,
      o = e.scrolling,
      s = e.children,
      l = e.horizontal,
      u = o ? "scroll" : "hidden";
    return React.createElement("div", {
      ref: "container",
      onScroll: this.onScroll,
      onWheel: o ? this.scrollStop : null,
      onTouchStart: o ? this.scrollStop : null,
      style: _extends({
        position: "absolute",
        width: "100%",
        height: "100%",
        overflow: u,
        overflowY: l ? "hidden" : u,
        overflowX: l ? u : "hidden",
        WebkitOverflowScrolling: "touch",
        WebkitTransform: "translate(0,0)",
        MsTransform: "translate(0,0)",
        transform: "translate3d(0,0,0)"
      }, n),
      className: a
    }, this.state.ready && React.createElement("div", {
      ref: "content",
      style: _extends((t = {
        position: "absolute"
      }, t[l ? "height" : "width"] = "100%", t.WebkitTransform = "translate(0,0)", t.MsTransform = "translate(0,0)", t.transform = "translate3d(0,0,0)", t.overflow = "hidden", t[l ? "width" : "height"] = this.space * r, t), i)
    }, s));
  }, e;
}(React.PureComponent);
Parallax.defaultProps = {
  config: config.slow,
  scrolling: !0,
  horizontal: !1
}, Parallax.childContextTypes = {
  parallax: PropTypes.object
}, Parallax.Layer = (_temp = _class = function (t) {
  function e(e, n) {
    var i;
    i = t.call(this, e, n) || this;
    var r = n.parallax,
      a = Math.floor(e.offset) * r.space,
      o = r.space * e.offset + a * e.speed,
      s = parseFloat(-r.current * e.speed + o);
    return i.animatedTranslate = new exports$2.Value(s), i.animatedSpace = new exports$2.Value(r.space * e.factor), i;
  }
  _inheritsLoose(e, t);
  var n = e.prototype;
  return n.componentDidMount = function () {
    var t = this.context.parallax;
    t && (t.layers = t.layers.concat(this), t.update());
  }, n.componentWillUnmount = function () {
    var t = this,
      e = this.context.parallax;
    e && (e.layers = e.layers.filter(function (e) {
      return e !== t;
    }), e.update());
  }, n.setPosition = function (t, e, n) {
    void 0 === n && (n = !1);
    var i = this.context.parallax.props.config,
      r = Math.floor(this.props.offset) * t,
      a = t * this.props.offset + r * this.props.speed,
      o = parseFloat(-e * this.props.speed + a);
    n ? this.animatedTranslate.setValue(o) : exports$2.spring(this.animatedTranslate, _extends({
      toValue: o
    }, i)).start();
  }, n.setHeight = function (t, e) {
    void 0 === e && (e = !1);
    var n = this.context.parallax.props.config,
      i = parseFloat(t * this.props.factor);
    e ? this.animatedSpace.setValue(i) : exports$2.spring(this.animatedSpace, _extends({
      toValue: i
    }, n)).start();
  }, n.render = function () {
    var t,
      e = this.props,
      n = e.style,
      i = e.children,
      r = (e.offset, e.speed, e.factor, e.className),
      a = _objectWithoutProperties(e, ["style", "children", "offset", "speed", "factor", "className"]),
      o = this.context.parallax.props.horizontal,
      s = this.animatedTranslate.interpolate({
        inputRange: [0, 1],
        outputRange: o ? ["translate3d(0px,0,0)", "translate3d(1px,0,0)"] : ["translate3d(0,0px,0)", "translate3d(0,1px,0)"]
      });
    return React.createElement(animated.div, _extends({}, a, {
      ref: "layer",
      className: r,
      style: _extends((t = {
        position: "absolute",
        backgroundSize: "auto",
        backgroundRepeat: "no-repeat",
        willChange: "transform"
      }, t[o ? "height" : "width"] = "100%", t[o ? "width" : "height"] = this.animatedSpace, t.WebkitTransform = s, t.MsTransform = s, t.transform = s, t), n)
    }), i);
  }, e;
}(React.PureComponent), _class.contextTypes = {
  parallax: PropTypes.object
}, _class.defaultProps = {
  factor: 1,
  offset: 0,
  speed: 0
}, _temp);
var _initialiseProps$1 = function _initialiseProps$1() {
  var t = this;
  this.moveItems = function () {
    t.layers.forEach(function (e) {
      return e.setPosition(t.space, t.current);
    }), t.busy = !1;
  }, this.scrollerRaf = function () {
    return requestAnimationFrame(t.moveItems);
  }, this.onScroll = function (e) {
    var n = t.props.horizontal;
    t.busy || (t.busy = !0, t.scrollerRaf(), t.current = e.target[n ? "scrollLeft" : "scrollTop"]);
  }, this.update = function () {
    var e = t.props,
      n = e.scrolling,
      i = e.horizontal;
    t.refs.container && (t.space = t.refs.container[i ? "clientWidth" : "clientHeight"], n ? t.current = t.refs.container[i ? "scrollLeft" : "scrollTop"] : t.refs.container[i ? "scrollLeft" : "scrollTop"] = t.current = t.offset * t.space, t.refs.content && (t.refs.content.style[i ? "width" : "height"] = t.space * t.props.pages + "px"), t.layers.forEach(function (e) {
      e.setHeight(t.space, !0), e.setPosition(t.space, t.current, !0);
    }));
  }, this.updateRaf = function () {
    requestAnimationFrame(t.update), setTimeout(t.update, 150);
  }, this.scrollStop = function (e) {
    return t.animatedScroll && t.animatedScroll.stopAnimation();
  };
};
export { Spring, Transition, Trail, Parallax, config, template, animated, interpolate$1 as interpolate };